module.exports = __webpack_public_path__ + "img/banner.25fe37a4.png";